import { currencyBRL } from './currencyBRL';
import {
  ICheckoutResponse,
  ITaxesCalculateResponse
} from '../../../../../store/ducks/order-simulate-checkout-mvp/types';
import { currencyFormatter } from './formatterHelper';

const TAX_FIELDS: (keyof ITaxesCalculateResponse)[] = [
  'icms',
  'ipi',
  'cofins',
  'pis',
  'difal',
  'fcp',
  'st',
  'total_include_tax',
  'total_exclude_tax'
];

export const buildTaxesPayload = (
  taxesResponse: ITaxesCalculateResponse | undefined
): string | undefined => {
  if (!taxesResponse) return undefined;

  const taxMap: Record<string, number> = {};
  TAX_FIELDS.forEach((field) => {
    const value = taxesResponse[field];
    if (value > 0) taxMap[field] = value;
  });

  return Object.keys(taxMap).length > 0 ? JSON.stringify(taxMap) : undefined;
};

export const displayTaxes = (
  data: Pick<ICheckoutResponse, 'o_price_sap_totals'> | null
) => {
  const zeroBRL = currencyFormatter({ amount: 0, currency: currencyBRL });
  const taxes = [
    {
      title: 'ICMS',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.icms ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'PIS',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.pis ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'COFINS',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.cofins ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'IPI',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.ipi ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'ST',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.icms_st ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'FCP',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.fcp ?? '0'),
        currency: currencyBRL
      })
    },
    {
      title: 'DIFAL',
      value: currencyFormatter({
        amount: Number(data?.o_price_sap_totals.difal ?? '0'),
        currency: currencyBRL
      })
    }
  ];
  return taxes.filter((taxe) => taxe.value !== zeroBRL);
};
